module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote-medicine-ball-throw.bf33fed8.webp";